'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var updateProductPrice = function updateProductPrice(_ref) {
  var self = _ref.currentTarget;

  var container = (0, _Helpers.getContainer)({ self: self, type: 'product' });
  var id = container.dataset.containerId;

  var upsellPrice = parseFloat($(self).siblings('.upsell__wrapper').find('.money').text().slice(1));
  var currentPrice = parseFloat($(_Dom2.default.price, container).text().slice(1));
  var newPrice = $(self).is(':checked') ? currentPrice + upsellPrice : currentPrice - upsellPrice;

  PubSub.publish(_Constants2.default.updateProductPrice, { id: id, price: newPrice });
};

var bindActions = exports.bindActions = function bindActions() {
  // $(document).on('change', dom.pdpUpsellCheckbox, updateProductPrice);
};